export default [
    {
        "id": 1,
        "templateDisplayName": "TemplateName1",
        "settings": {
            "header": "header-1",
            "footer": "footer-1",
            "mainBody": [
                "mainBanner-1",
                "newsSection-1",
                "newsletter-1",
                "manufacturersSlider-1",
                "brandsSlider-1",
                "news-1",
                "infographicBanner-1"
            ],
            "productListBody": [
                "filterPanel-1",
                "categoryDescription-1",
                "products-1"
            ],
			"cartBody": [
				"cart-1"
			],
            "theme": "Default"
        },
        "newFlag": true,
        "thumbnail": "defaultTemplate1.png",
    },
    {
        "id": 2,
        "templateDisplayName": "TemplateName2",
        "thumbnail": "defaultTemplate2.png",
    },
    {
        "id": 3,
        "templateDisplayName": "TemplateName3",
        "thumbnail": "defaultTemplate3.png",
    },
    {
        "id": 4,
        "templateDisplayName": "TemplateName4",
        "thumbnail": "defaultTemplate4.png",
    }
]